import { ToastContainer } from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css'
import './assets/scss/toastify.scss'

import { ReactComponent as ErrorIcon } from './assets/icons/error.svg'
import { ReactComponent as CheckIcon } from './assets/icons/check.svg'

const Toasts = () => (
    <ToastContainer
        closeButton={false}
        closeOnClick={true}
        newestOnTop
        autoClose={3000}
        theme="colored"
        icon={({ type, theme }) => {
            switch (type) {
                case 'info':
                    return <CheckIcon />
                case 'error':
                    return <ErrorIcon />
                case 'success':
                    return <CheckIcon />
                case 'warning':
                    return <ErrorIcon />
                default:
                    return null
            }
        }}
    />
)

export default Toasts
